/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Country_SimulationInputs */

const en_pricing_country_simulation = /** @type {(inputs: Pricing_Country_SimulationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulate country`)
};

const es_pricing_country_simulation = /** @type {(inputs: Pricing_Country_SimulationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simular país`)
};

/**
* | output |
* | --- |
* | "Simulate country" |
*
* @param {Pricing_Country_SimulationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_country_simulation = /** @type {((inputs?: Pricing_Country_SimulationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Country_SimulationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_country_simulation(inputs)
	return en_pricing_country_simulation(inputs)
});